import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardTitle,
  Form,
  FormGroup,
  FormText,
  Input,
  Table,
  Row,
  Col
} from "reactstrap";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { 
  PanelHeader, 
  Button, 
  Statistics 
} from "components";

import { theadmobileprocedures, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

class MobileProceduresList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      servicesSize: "auto",
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas",
      toDashboard: false,
      customer: {
        id: 0
      },
      procedureStatus: ""
    };
    ////console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.createServicesButtons = this.createServicesButtons.bind(this);
    this.cancelProcedure = this.cancelProcedure.bind(this);
    this.createMobileProceduresCard = this.createMobileProceduresCard.bind(this);
    this.changeProcedureStatusView = this.changeProcedureStatusView.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }
  searchCustomer() {
    if(!this.props.mainState.isSearchingCustomer)
      this.props.searchCustomer(this.props.mainState.searchCustomerQuery);
  }
  cancelProcedure(mobileProcedure, customer) {
    this.props.cancelMobileProcedure(mobileProcedure, customer);
  }
  downloadBill(url, orderNumber, event){
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  goToDashboard() {
    this.setState({
      toDashboard: true
    });
  }
  paymentStatus(payment){
    let statusReady = null;
    if(payment.includes("Pendiente")){
      statusReady =                   
      <Button
        color="danger"
        size="sm"
      >
        <i className="now-ui-icons ui-1_simple-remove" /> {payment}
      </Button>;  
    } else{
      statusReady =                   
      <Button
        color="primary"
        size="sm"
      >
        <i className="now-ui-icons ui-1_check" /> {payment}
      </Button>;  
    }

    return statusReady;
  }
  downloadButton(order){
    let button = 
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>;

    if(this.state[order]){
      button = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }

    return button;
  }
  handleChange(field, event) {
    if (field === "searchQuery") {
      this.props.setSearchCustomerQuery(event.target.value);
      return;
    }
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  viewOrderArticles(order){
    let orderDetailContent =
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">
                Concepto
              </th>
              <th className="text-center">
                Precio
              </th>     
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>;
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    })
  }
  createServicesButtons(customer) {
    let buttons = undefined;
    if (!this.props.mainState.customersMobilesLoaded) {
      buttons = 
      <Button
        color="default"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>
      </Button>
    } else {
      let mobilesQuantity = 0;
      if (customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[customer.id].length;
      }

      buttons = 
      <Button
        color={(mobilesQuantity > 0) ? "primary" : "default"}
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons tech_mobile" /> {mobilesQuantity}
        </div>
      </Button>      
    }
    
    return buttons;
  }
  createActiveCustomerButton(customer) {
    let button = undefined;
    if (customer.renovar_activo === "1") {
      button = 
      <Button
        color="primary"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons ui-1_check" /> Activo
        </div>
      </Button>
    } else {
      button = 
      <Button
        color="default"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons media-1_button-pause" /> Inactivo
        </div>
      </Button>
    }
    
    return button;
  }
  createProcedureState(procedure) {
    let procedureState = null;

    let procedureStateColor = "default";
    let procedureStateIcon = "default";
    let procedureStateText = procedure.estado_tramite;

    switch (procedure.estado_tramite) {
      case "Pendiente": 
        procedureStateColor = "default";
        procedureStateIcon = "travel_info";
        break;
      case "Procesando": 
        procedureStateColor = "warning";
        procedureStateIcon = "loader_refresh spin";
        break;
      case "Error": 
        procedureStateColor = "danger";
        procedureStateIcon = "health_ambulance";
        break;
      case "Aceptado": 
        procedureStateColor = "info";
        procedureStateIcon = "ui-1_check";
        break;
      case "Finalizado": 
        procedureStateColor = "primary";
        procedureStateIcon = "ui-2_favourite-28";
        break;
      case "ICC previo incorrecto": 
        procedureStateColor = "danger";
        procedureStateIcon = "ui-2_settings-90";
        break;
      case "Rechazado": 
        procedureStateColor = "danger";
        procedureStateIcon = "ui-2_time-alarm";
        procedureStateText = procedureStateText + " [" + procedure.motivo_rechazo + "]"
        break;
      case "Cancelado": 
        procedureStateColor = "default";
        procedureStateIcon = "media-1_button-power";
        break;
      default:
    }

    procedureState = 
      <div className="btns-mr-5">
        <Button
          color={procedureStateColor}
          size="sm"
        >
          <i className={"now-ui-icons " + procedureStateIcon} />{" "}
          {procedureStateText}
        </Button>
      </div>;
    return procedureState;
  }
  changeProcedureStatusView(procedureStatus) {
    this.setState({
      procedureStatus: procedureStatus
    });
    this.props.searchMobileProcedures(procedureStatus, true);
    // alert("Pulsado " + procedureStatus);

  }
  createMobileProceduresCard() {
    let mobileContent = null;
    if(this.props.mainState.mobileProceduresCountLoaded && this.props.mainState.mobileProceduresCount.length > 0){
      mobileContent = [];

      this.props.mainState.mobileProceduresCount.map((procedureType, key) => {
        let _procedureStatus = procedureType.estado_tramite;
        let isCurrentStatus = _procedureStatus === this.state.procedureStatus;
        mobileContent.push(
          <Col xs={12} md="auto" key={_procedureStatus}>
            <Card className="card-stats card-raised" 
              onClick={() => {this.changeProcedureStatusView(_procedureStatus)}}
              style={{cursor: "pointer"}}
              color={isCurrentStatus ? "primary" : ""}>
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    {/* <Link to={"/tramites"}> */}
                      {this.createMobileProceduresStyle(procedureType)}
                    {/* </Link> */}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    } else if (this.props.mainState.mobileProceduresCountLoaded){
      mobileContent = 
        <Statistics
          showIcon
          iconState="danger"
          icon="education_paper"
          title={0}
          subtitle="Ningún trámite en proceso"
        />;
    } else {
      mobileContent = 
        <Statistics
          showIcon
          iconState="default"
          icon="now-ui-icons arrows-1_refresh-69 spin"
          title="Cargando..."
          subtitle="Trámites"
        />;
    }

    return mobileContent;
  }
  createMobileProceduresStyle(procedureType) {
    let statistic = null;
    let procedureStateColor = "default";
    let procedureStateIcon = "default";
    let procedureStateText = /*"Trámites " + */procedureType.estado_tramite;
    let isCurrentStatus = procedureType.estado_tramite === this.state.procedureStatus;

    switch (procedureType.estado_tramite) {
      case "Pendiente": 
        procedureStateColor = "default";
        procedureStateIcon = "travel_info";
        procedureStateText = procedureStateText + "s";
        break;
      case "Procesando": 
        procedureStateColor = "warning";
        procedureStateIcon = "loader_refresh spin";
        break;
      case "Error": 
        procedureStateColor = "danger";
        procedureStateIcon = "health_ambulance";
        // procedureStateText = "Trámites con " + procedureType.estado_tramite;
        break;
      case "Aceptado": 
        procedureStateColor = "info";
        procedureStateIcon = "ui-1_check";
        procedureStateText = procedureStateText + "s";
        break;
      case "Finalizado": 
        procedureStateColor = "primary";
        procedureStateIcon = "ui-2_favourite-28";
        procedureStateText = procedureStateText + "s";
        break;
      case "ICC previo incorrecto": 
        procedureStateColor = "danger";
        procedureStateIcon = "ui-2_settings-90";
        procedureStateText = /*"Trámites "error */"prev icc";
        break;
      case "Rechazado": 
        procedureStateColor = "danger";
        procedureStateIcon = "ui-2_time-alarm";
        procedureStateText = procedureStateText + "s";
        // procedureStateText = procedureStateText + " [" + procedure.motivo_rechazo + "]"
        break;
      case "Cancelado": 
        procedureStateColor = "default";
        procedureStateIcon = "media-1_button-power";
        procedureStateText = procedureStateText + "s";
        break;
      default:
    }

    if (isCurrentStatus) {
      procedureStateText = 
      <span className="text-center" style={{color: "#FFF"}}>{procedureStateText}</span>;
      procedureStateColor = "info";
    } 

    statistic =
      <Statistics
        showIcon
        iconState={procedureStateColor}
        icon={procedureStateIcon}
        title={procedureType.contador}
        subtitle={procedureStateText}
      />;

    return statistic;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  render() {
    if (this.state.toDashboard === true) {
      this.redirectTo("/dashboard");
      // return <Redirect to="/dashboard" />;
    }
    //if (this.props.mainState.ordersLoaded && !this.state.ordersChartReady && this.props.mainState.orders.length > 0) this.loadCustomersChart();
    let contentToDisplay = null;
    let mobileProceduresToDisplay = null;
    //console.log("######## MAINSTATE EN MOBILE PROCEDURES #######");
    //console.log(this.props.mainState);
    /*El identificador 0 es el que agrupa todos los procedimientos*/
    // if(!(0 in this.props.mainState.mobileProcedures) && !(0 in this.props.mainState.isSearchingMobileProcedures && this.props.mainState.isSearchingMobileProcedures[0])) {
    //   this.props.searchMobileProcedures();
    // }
    // console.log("############ MAINSTATE EN MOBILEPROCEDURES LIST ############")
    // console.log(this.props.mainState);
    let currentStatus = this.state.procedureStatus? this.state.procedureStatus : 0;
    if(currentStatus in this.props.mainState.mobileProcedures && this.props.mainState.mobileProcedures[currentStatus].length > 0){
      mobileProceduresToDisplay = this.props.mainState.mobileProcedures[currentStatus];
      //console.log("######## MOBILE PROCEDURES TO DISPLAY #######");
      //console.log(mobileProceduresToDisplay);
      let isSearchingCustomer = false;
      contentToDisplay = 
      <Col xs={12}>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Lista de trámites</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr className="text-primary">
                  {theadmobileprocedures.map((prop, key) => {
                    if (key === theadmobileprocedures.length - 1)
                      return (
                        <th key={key} className="text-center">
                          {prop}
                        </th>
                      );
                    return <th key={key} className="text-center">{prop}</th>;
                  })}
                </tr>
              </thead>
            <tbody>
              {mobileProceduresToDisplay.map((procedure, key) => {
                let mobilePlan = procedure.tarifa.replace("(Nueva) ", "").replace(" (Móvil)", "");
                let formattedNumber = "";
                if (procedure.numero && typeof procedure.numero === 'string') {
                  formattedNumber = procedure.numero.substring(0, 3) + " " + procedure.numero.substring(3, 6)
                    + " " + procedure.numero.substring(6, 9);
                }
                let procedureState = this.createProcedureState(procedure);

                let currentCustomer = null;
                let currentCustomerLink = null;
                if(procedure.cliente in this.props.mainState.customers) {
                  currentCustomer = this.props.mainState.customers[procedure.cliente][0];
                  currentCustomerLink = 
                    <Link to={"/clientes/fichas/".concat(currentCustomer.id)}>
                      {currentCustomer.nombre_completo} {currentCustomer.primer_apellido} {currentCustomer.segundo_apellido}
                    </Link>;
                } else {
                  //if (!isSearchingCustomer) this.props.searchCustomer();
                  //isSearchingCustomer = true;
                  currentCustomerLink =                       
                    <div className="btns-mr-5">
                      <Button icon color="default" size="sm">
                        <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
                      </Button>
                    </div>;
                }
                let procedureAction = null;                
                //if(this.props.mainState.user.field_tipo_distribuidor.und[0].tid != 180) {
                  procedureAction =
                    <div className="btns-mr-5">
                      <Button icon color="default" size="sm" onClick={(e) => {
                          e.preventDefault(); this.cancelProcedure(procedure.id_tramite, this.state.customer.id);
                          }
                        }>
                        <i className="now-ui-icons ui-1_simple-remove" />
                      </Button>
                    </div>;
                  if (this.state.customer.id in this.props.mainState.isCancellingMobileProcedure 
                      && procedure.id_tramite in this.props.mainState.isCancellingMobileProcedure[this.state.customer.id] 
                      && this.props.mainState.isCancellingMobileProcedure[this.state.customer.id][procedure.id_tramite]) {
                    procedureAction = 
                    <div className="btns-mr-5">
                      <Button icon color="info" size="sm">
                        <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
                      </Button>
                    </div>;
                  }
                  if (procedure.estado_tramite !== "Pendiente" || procedure.estado_tramite !== "Error") {
                    procedureAction = null;
                  }
                //}
                return (
                  <tr key={procedure.id_tramite}>
                    <td className="text-center">{procedure.creacion}</td>
                    <td className="text-center">{procedure.fecha_cambio}</td>
                    <td className="text-center">{procedure.autor}</td>
                    <td className="text-center">{currentCustomerLink}</td>
                    <td className="text-center">{procedure.tipo_tramite}</td>
                    <td className="text-center">{formattedNumber}</td>
                    <td className="text-center">{mobilePlan}</td>
                    <td className="text-center">{procedure.icc}</td>
                    <td className="text-center">{procedure.tipo_contrato_anterior}</td>
                    <td className="text-center">{procedure.icc_prev}</td>
                    <td className="text-left">{procedureState}</td>
                    <td className="text-center">{procedureAction}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          </CardBody>
        </Card>
      </Col>;
    }else if (currentStatus in this.props.mainState.mobileProcedures && this.props.mainState.mobileProcedures[currentStatus].length == 0) { 
      contentToDisplay = 
      <Col xs={12}>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Lista de trámites</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              {/* <thead>
                <tr className="text-primary">
                  <th className="text-center">
                    
                  </th>
                </tr>
              </thead> */}
            <tbody>
              <tr>
                <td className="text-center">No hay resultados...</td>
              </tr>
            </tbody>
          </Table>
          </CardBody>
        </Card>
      </Col>;
    }else if(this.props.mainState.isSearchCustomerResult && this.props.mainState.customersLoaded && Object.keys(this.props.mainState.customers).length == 0) {
      
      contentToDisplay = 
      <Col xs={12}>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Lista de clientes</CardTitle>
          </CardHeader>
          <CardBody>
            <Row>
              {/*<Label sm={2}>Buscar</Label>*/}
              <Col xs={12} sm={10}>
                No hay resultados para <b>{this.props.mainState.searchCustomerQuery}</b>...
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>;
    }else {     
      contentToDisplay = 
      <Col xs={12}>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Lista de trámites</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              {/* <thead>
                <tr className="text-primary">
                  <th className="text-center">
                    
                  </th>
                </tr>
              </thead> */}
            <tbody>
              <tr>
                <td className="text-center">
                  <i className="now-ui-icons arrows-1_refresh-69 spin" />
                    {"  Cargando trámites..."}
                </td>
              </tr>
            </tbody>
          </Table>
          </CardBody>
        </Card>
      </Col>;
    }

    let orderArticles = 
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Detalles de la factura"
        onConfirm={() => this.hideDetail()}
        showConfirm={true}
      >
        {this.state.orderDetail}
      </SweetAlert>;
    return (
      <div>
        <PanelHeader
          size="sm"
          /* content={
            <div className="header text-center">
              <h2 className="title">Lista de clientes</h2>
              {<p className="category"></p>}
            </div>
          }*/
        />
        <div className="content">
          {/*<Row>
            <Col lg={3} md={6} xs={12}>
              <Card>
                <CardBody className="form-inline">
                  <Input type="text" 
                    placeholder="Buscar cliente..."
                    value={this.props.mainState.searchCustomerQuery}
                    onChange={(e) => this.handleChange("searchQuery", e)}
                    onKeyDown={e => {
                      //console.log(e.keyCode);
                      if(e.keyCode == 13){
                        //Enter is key code 13
                        this.searchCustomer();
                        // put the login here
                      }
                    }}
                    style={{marginRight:"10px"}}
                  />
                  <Button
                    color={
                      this.props.mainState.isSearchingCustomer
                        ? "default"
                        : "primary"
                    }
                    round 
                    icon 
                    onClick={this.searchCustomer}>
                <i className={this.props.mainState.isSearchingCustomer?
                                      "now-ui-icons arrows-1_refresh-69 spin reposition-spin" :"now-ui-icons ui-1_zoom-bold"} />
              </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>*/}
          <Row>
            {this.createMobileProceduresCard()}
          </Row>
          <Row>
            {this.state.showDetail && orderArticles}
            {contentToDisplay}
          </Row>
        </div>
      </div>
    );
  }
}

export default MobileProceduresList;



// WEBPACK FOOTER //
// ./src/views/MobileProcedures/MobileProceduresList.jsx